import { parseISO, isValid } from "date-fns"
import type { UserProfile } from "@models/userProfile.model"

export interface ComplianceStatus {
	compliant: boolean
}

function isPasswordCompliant(profile: UserProfile): boolean {
	if (!profile.lastPasswordChangeDate) return false
	const lastUpdateDate = parseISO(profile.lastPasswordChangeDate)
	if (!isValid(lastUpdateDate)) return false
	const cutoffDateString = "2025-09-14"
	const cutoffDate = parseISO(cutoffDateString)
	if (!isValid(cutoffDate)) {
		const fallbackDate = new Date(2025, 8, 14)
		return lastUpdateDate > fallbackDate
	}
	return lastUpdateDate > cutoffDate
}

export function getComplianceStatus(
	profile: UserProfile | null
): ComplianceStatus {
	if (!profile) return { compliant: false }
	const hasRequiredInfo =
		Boolean(profile.agentFirstName?.trim()) &&
		Boolean(profile.agentLastName?.trim()) &&
		Boolean(profile.agentEmailAddress?.trim())
	const hasMfaEnabled = Boolean(
		profile.primaryMFA?.trim() &&
			["EMAIL", "SMS"].includes(profile.primaryMFA.trim().toUpperCase())
	)
	const emailValidated = profile.emailValidatedFlag === true
	const emailIsUsername = profile.emailIsUsername === true
	const compliant =
		hasRequiredInfo &&
		hasMfaEnabled &&
		isPasswordCompliant(profile) &&
		emailValidated &&
		emailIsUsername
	return { compliant }
}
